import React, { forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck'

export const Checkbox = forwardRef((props, ref) => {
    const { className, checked, label, ...restProps } = props

    return (
        <>
            <label className={`flex text-sm cursor-pointer gap-x-[15px] items-center`}>
                <input
                    ref={ref}
                    type="checkbox"
                    checked={checked}
                    className={`hidden`}
                    {...restProps}
                />
                <span
                    className={twMerge(
                        `relative block w-4 h-4 border-2 cursor-pointer rounded ${
                            checked
                                ? 'bg-brand-secondary border-brand-secondary'
                                : 'bg-transparent border-brand-black'
                        } ${className}`
                    )}
                >
                    {checked && (
                        <span
                            className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center`}
                        >
                            <FontAwesomeIcon
                                icon={faCheck}
                                className={`text-brand-white text-xs`}
                            />
                        </span>
                    )}
                </span>
                {label}

                {props.required && <sup className="text-brand-danger">*</sup>}
            </label>
        </>
    )
})
